import { HttpService } from '@/services/HttpService';

class Recaptcha {
  subdomain = '/recaptcha';

  assess(data) {
    return HttpService.post(`${this.subdomain}/assess`, data);
  }
}

export default new Recaptcha();
